import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import { MomentDate } from '../common/momentComponent';
import { bindActionCreators } from 'redux';
import { reportActions } from '../../store/reportStore';
import { isNullOrUndefined } from '../../store/storeFunctions';
import DoubleArrowIcon from '../../img/icons/BBiconsRozbalitVse';

import './reportExpander.scss';

class ReportExpander extends Component {
    reportMenuNode = undefined;

    render() {
        return (
            <div className='report-expander-wrapper'>
                <span>
                    <Translate id="Report.Date" />:&nbsp;
                    <span style={{ fontWeight: 600 }}>
                        <MomentDate value={isNullOrUndefined(this.props.reportDate) ? new Date() : this.props.reportDate} />
                    </span>
                </span>
                <div>
                    <span className="expand-collapse-all" onClick={() => this.props.expand()}>
                        {this.props.sections && <>
                            <Translate id={"Report.ExpandAll"} />
                            <DoubleArrowIcon
                                className='svg-standard-fill'
                                style={{
                                    marginLeft: '0.3em', marginRight: '0.3em', height: '1.6em', width: '1.6em',
                                    transform: 'scaleY(1)',
                                    transition: 'all .5s ease'
                                }}
                            />
                        </>}
                    </span>
                    <span className="expand-collapse-all" onClick={() => this.props.collapse()}>
                        {this.props.sections && <>
                            <Translate id="Report.CollapseAll" />
                            <DoubleArrowIcon
                                className='svg-standard-fill'
                                style={{
                                    marginLeft: '0.3em', marginRight: '0.3em', height: '1.6em', width: '1.6em',
                                    transform: 'scaleY(-1)',
                                    transition: 'all .5s ease'
                                }}
                            />
                        </>}
                    </span>
                </div>
            </div>
        )
    }
}

export default connect(
    state => state.report,
    dispatch => bindActionCreators(reportActions, dispatch)
)(ReportExpander);
